import { LoginScreen } from "@/screens/login";

/** Thin wrapper — toda lógica fica em screens/login */
export function LoginPage() {
  return <LoginScreen />;
}
